var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","color":"black "},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){_vm.trataAcaoDeBotaoDesabilitado(function () { return _vm.$emit('click'); })}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":_vm.cor}},[_vm._v(" "+_vm._s(_vm.icone)+" ")])],1)]}}])},[(_vm.texto)?_c('span',[_vm._v(_vm._s(_vm.texto))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }